import { ShopContext } from '../Context/ShopContext';
import { roundOff } from 'helpers/NumberFormatHelper';
import { TAX_PREFERENCE } from 'const';
import { useContext } from 'react';

export const StockTransferHelper = () => {
  const { shop } = useContext(ShopContext);

  const getStockTransferItemUnitRate = (item, profitPercentage = 0, rateCalculationMode = 'cost') => {
    if (!item) return 0;
    if (rateCalculationMode === 'price') {
      return item.price || 0;
    }
    const cost = item.cost || 0;
    if (profitPercentage === 0) {
      return cost;
    }
    const profitAmount = (cost * profitPercentage) / 100;
    return roundOff(cost + profitAmount);
  };


  const getItemUnitRate = (item, cartItem = {}) => {
    const { tax, cess } = item;
    const price = cartItem?.price ?? item.price;

    if (shop?.tax_preference === TAX_PREFERENCE.INCLUDING_TAX) {
      let taxDeducted = (price * 100) / (tax + 100);
      return roundOff((taxDeducted * 100) / (cess + 100));
    }
    return price;
  };

  const getItemUnitRateByPayable = (item = {}) => {
    const { tax = 0, cess = 0, payable = 0, quantity = 1 } = item;

    if (!payable || quantity === 0) return 0;

    const taxMultiplier = 1 + tax / 100;
    const cessMultiplier = 1 + cess / 100;
    const unitTotal = payable / quantity;
    const price = unitTotal / (taxMultiplier * cessMultiplier);

    return roundOff(price);
  };

  const getItemUnitRateWithTax = (item) => {
    const { price, tax, cess } = item;

    if (shop?.tax_preference === TAX_PREFERENCE.INCLUDING_TAX) {
      let priceWithCess = (price * (cess + 100)) / 100;
      return roundOff((priceWithCess * (tax + 100)) / 100);
    }
    return price;
  };

  const getItemCess = (item) => {
    const price = item.itemAmount ?? roundOff((item.quantity || 0) * (item.rate || 0));
    const cessRate = item.cess_percent ?? item.item?.cess ?? (typeof item.cess === 'number' && item.cess <= 100 ? item.cess : 0);
    return roundOff((price * cessRate) / 100);
  };

  const getItemTax = (item) => {
    const price = item.itemAmount ?? roundOff((item.quantity || 0) * (item.rate || 0));
    const taxRate = item.tax_percent ?? item.item?.tax ?? (typeof item.tax === 'number' && item.tax <= 100 ? item.tax : 0);
    const cess = getItemCess(item);
    let tax = 0;

    if (!shop?.tax_preference || [TAX_PREFERENCE.INCLUDING_TAX, TAX_PREFERENCE.EXCLUDING_TAX].includes(shop?.tax_preference)) {
      tax = ((price + cess) * taxRate) / 100;
    }

    return roundOff(tax);
  };

  return {
    getItemUnitRate,
    getItemUnitRateByPayable,
    getItemUnitRateWithTax,
    getItemCess,
    getItemTax,
    getStockTransferItemUnitRate,
  };
};
